import React from 'react';
import {Icon} from 'components';
import {over, getElementAttributes} from 'helpers';
import css from './edit.module.scss';

export function FormField({ Wrapper = 'label', label, children, Prefix, Suffix, clear, className, ...props }) {
  return (
    <Wrapper {...getElementAttributes(props)} className={css('wrapper', className, props.onClick && 'clickable')}>
      { label &&
        <FormField.Label>{ label }</FormField.Label>
      }
      { Prefix &&
        <Prefix {...props} className={css.prefix} />
      }
      { children }
      { Suffix &&
        <Suffix {...props} className={css.suffix} />
      }
      { label && !Boolean(props.value) &&
        <span className={css.plus}>+</span>
      }
      { clear && Boolean(props.value) &&
        <span className={css.clear}>
          <Icon name="close-small" onClick={over(clear, blur)} />
        </span>
      }
    </Wrapper>
  );
}

FormField.Label = function Label({ children }) {
  return (
    <span className={css.label}>
      { children }
    </span>
  );
}

function blur(event) {
  event.stopPropagation();
  event.preventDefault();
  window.document.activeElement.blur();
}
